define('helperContent-cloneInitEntity',['helperContent-getEntity', 'helperContent-cloneEntity', 'helperContent-getQuizGame'], function(getEntity, cloneEntity, getQuizGame) {
    'use strict';

     // Clone entity to start with in Training
    var cloneInitEntity = function(training, user, previewMode, previewID) {
        var entity = null,
            game = null,
            hash = (location.hash && location.hash.indexOf('#') > -1) ? location.hash.substr(1) : '',
            isParentQuiz = function(entity, entities) {
                var parentID = entity.contentEntity.parentId,
                    parentEntity;

                if (parentID) {
                    parentEntity = getEntity(parentID, entities);
                }

                return (parentEntity && parentEntity.hasOwnProperty('typeId') && parentEntity.typeId === 19) ? true : false;
            },
            entities = (training && training.hasOwnProperty('contentEntities')) ? training.contentEntities : null,
            fromLastVisited = (training && training.hasOwnProperty('continueFromLastVisitedPage') && training.continueFromLastVisitedPage) ? true : false,
            lastVisitedID = (user && user.hasOwnProperty('lastVisitedContentEntityId') && user.lastVisitedContentEntityId) ? user.lastVisitedContentEntityId : false;

        if (!Array.isArray(entities) || entities.length === 0) {
            return null;
        }

        if (fromLastVisited && lastVisitedID) {
            entity = getEntity(lastVisitedID, entities);
        }

        if (hash) {
            entity = getEntity(hash, entities);
        }

        if (entity) {
            game = getQuizGame(entity.contentEntity.parentId, entities);
        }

        if (entity && game && game.isQuizGame) {
            entity = getEntity(game.ID, entities);
        } else if (entity && isParentQuiz(entity, entities)) {
            entity = getEntity(entity.contentEntity.parentId, entities);
        }

        if (previewMode && previewID) {
            entity = getEntity(previewID, entities);
        }

        if (!entity) {
            entity = entities[0];
        }

        return (entity) ? cloneEntity(entity) : null;
    };

    return cloneInitEntity;
});

